import { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/hooks/useStores';
import { lazyRoute } from '@/routing/lazyRoute';

const ItemCreatedToast = lazyRoute(
  () => import('./ItemCreatedToast'),
  (module) => module.ItemCreatedToast,
);

/**
 * Where `ItemCreatedToast` mounts (`Layout.tsx`), loaded only once an Add has raised a toast, so the
 * launch entry carries the store and none of the `workItems` words the toast says (I-1977).
 */
export const ItemCreatedToastSlot = observer(function ItemCreatedToastSlot() {
  const { itemCreatedToastStore } = useStores();
  if (!itemCreatedToastStore.toast) return null;
  return (
    <Suspense fallback={null}>
      <ItemCreatedToast />
    </Suspense>
  );
});
